import { IRule, IRuleAction, IRuleTrigger } from "store/entities/rules/interfaces";

import { WorkflowActionType, WorkflowConditionType } from "../../interfaces";

export type IRuleForm = Omit<IRule, "actions" | "triggers"> & {
  actions: IRuleAction[];
  triggers: IRuleTrigger[];
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const conditionType = (trigger: Partial<IRuleTrigger>) => {
  switch (trigger.type) {
    case "teamID":
      return WorkflowConditionType.Team;
    case "status":
      return WorkflowConditionType.Status;
    case "isNew":
      return trigger.eq ? WorkflowConditionType.TicketCreated : WorkflowConditionType.TicketChanged;
    case "hasAssignee":
      return WorkflowConditionType.Agent;
    case "isSpam":
      return trigger.eq ? WorkflowConditionType.IsSpam : WorkflowConditionType.IsNotSpam;
    case "detailedSourceType":
      return WorkflowConditionType.Source;
    case "statusChanged":
      return WorkflowConditionType.StatusChanged;
    case "priority":
      return WorkflowConditionType.Priority;
    case "priorityChanged":
      return WorkflowConditionType.PriorityChanged;
    case "secondsPassedSinceEvent":
      return WorkflowConditionType.Time;
    case "eventCount":
      return WorkflowConditionType.EventCount;
    case "agentID":
      return WorkflowConditionType.Agent;
    case "requesterEmail":
      return WorkflowConditionType.Requester;
    case "subject":
      return WorkflowConditionType.Subject;
    case "teamChanged":
      return WorkflowConditionType.TeamChanged;
    case "agentChanged":
      return WorkflowConditionType.AgentChanged;
    case "newMessage":
      return WorkflowConditionType.NewRequesterMessage;
    case "newAgentMessage":
      return trigger.isPrivate !== undefined
        ? trigger.isPrivate
          ? WorkflowConditionType.NewPrivateAgentMessage
          : WorkflowConditionType.NewPublicAgentMessage
        : WorkflowConditionType.NewAnyAgentMessage;
    case "sourceMailbox":
      return WorkflowConditionType.Mailbox;
    case "tagID":
    case "tagRemoved":
    case "tagAdded":
      return WorkflowConditionType.Tag;
    case "followerID":
    case "followerRemoved":
    case "followerAdded":
      return WorkflowConditionType.Follower;
    case "rating":
    case "ratingChanged":
      return WorkflowConditionType.Rating;
    case "language":
      return WorkflowConditionType.Language;
    default:
      return null;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const actionType = (action: Partial<IRuleAction>) => {
  switch (action.type) {
    case "assign":
      return WorkflowActionType.Assign;
    case "sendRatingRequest":
      return WorkflowActionType.FeedbackRequest;
    case "sendFollowUp":
      return WorkflowActionType.FollowUp;
    case "message":
      return action.isPrivate ? WorkflowActionType.PrivateNote : WorkflowActionType.Message;
    case "status":
      return WorkflowActionType.Status;
    case "priority":
      return WorkflowActionType.Priority;
    case "spam":
      return action.spam ? WorkflowActionType.Spam : WorkflowActionType.Unspam;
    case "addTags":
      return WorkflowActionType.AddTag;
    case "removeTags":
      return WorkflowActionType.RemoveTag;
    case "addFollowers":
      return WorkflowActionType.AddFollowers;
    case "removeFollowers":
      return WorkflowActionType.RemoveFollowers;
    default:
      return null;
  }
};
